export const DEPLOYMENT_EVENTS_LOG_TYPE = 'logzio-k8s-events';

/** Rollouts one request returns, across every matching object. Restores the flat bound the script query had. */
export const DEPLOYMENT_EVENTS_PAGE_SIZE = 500;

/** Pages walked before a result is reported as truncated. */
export const DEPLOYMENT_EVENTS_MAX_PAGES = 3;

/** Rollouts one fetch can return in total — the figure a truncation warning reports. */
export const DEPLOYMENT_EVENTS_ROLLOUT_LIMIT = DEPLOYMENT_EVENTS_PAGE_SIZE * DEPLOYMENT_EVENTS_MAX_PAGES;

export const DEPLOYMENT_EVENT_SOURCE_FIELDS = [
  '@timestamp',
  'env_id',
  'newObject.metadata',
  'oldObject.metadata.generation',
  'newObject.spec.template.metadata.annotations',
];
